module.exports = __webpack_public_path__ + "img/employee-interview-primary.94344a16.svg";